<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT_APPOINTMENT|Potwierdź przesłanie protokołu serwisowego' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="flex-vertical w-100">

            <h2 *ngIf="!data.appointment.protocolPdfSentOn">{{ 'COMPLAINT_APPOINTMENT|Czy wysłać protokół serwisowy na adres email klienta wskazany w zgłoszeniu?' | translate }}</h2>

            <h2 *ngIf="data.appointment.protocolPdfSentOn">{{ 'COMPLAINT_APPOINTMENT|Protokół serwisowy został wysłany w dniu {protocolPdfSentOn}. Czy wysłać protokół ponownie?' | translate: { protocolPdfSentOn: data.appointment.protocolPdfSentOn | date: 'shortDate' } }}</h2>

        </div>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Nie' | translate}}
            </button>
            <button
                iccButton
                (click)="sendEmail()"
                appearance="primary"
            >
                {{ 'INTERFACE|Tak' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>